var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('button',{on:{"click":_vm.print}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"printMe"}},[_c('h1',[_vm._v("Print me!")])])}]

export { render, staticRenderFns }